/**
 * Parse notification emails from a string of comma/semicolon/newline entries.
 *
 * @param value - Raw input string.
 * @returns Lowercased, deduplicated email list.
 *
 * @example
 * parseNotificationEmails('A@b.com; c@d.com') // ["a@b.com","c@d.com"]
 */
export function parseNotificationEmails(value: string): string[] {
  const rawEntries = value
    .split(/[\n,;]+/)
    .map((entry) => entry.trim())
    .filter(Boolean);
  const normalized = rawEntries.map((entry) => entry.toLowerCase());
  return Array.from(new Set(normalized));
}
